export default {
  updateModels(state, data) {
    if (data.length < 1) {
      state.models = null;
    } else {
      state.models = data;
    }
  },

  updateMaterialsItem(state, val = null) {
    state.materialsItem = val;
  },

  updateIsDisabledMaterials(state, val = true) {
    state.isDisabledMaterials = val;
  },

  updateIsDisabledSizes(state, val = true) {
    state.isDisabledSizes = val;
  },

  updateIsDisabledOptions(state, val = true) {
    state.isDisabledOptions = val;
  },

  resetAllAccordion(state) {
    state.isDisabledMaterials = true;
    state.isDisabledSizes = true;
    state.isDisabledOptions = true;
    state.triggerResetData += 1;
  },

  // deprecated use updateSystemItem
  updateSystem(state, val = null) {
    state.system = val;
  },

  updateSystemItem(state, systemItem = null) {
    const findIndex = state.models.findIndex(el => el.id === systemItem.id);

    state.system = findIndex > -1 ? findIndex : null;
  },

  updateModel(state, val = null) {
    state.model = val;
  },

  updateSubModel(state, val) {
    state.subModel = val;
  },

  updateMaterials(state, data) {
    state.materials = data;
    for (let i = 0; i < state.materials.length; i++) {
      if (
        state.materials[i].material.material_collection.composition !== null &&
        state.materials[i].material.material_collection.composition !== ''
      ) {
        state.materials[i].material.material_collection.composition = state.materials[
          i
        ].material.material_collection.composition.replace(/[^a-zA-Z]/gi, '');
      }
    }
  },

  updateModelSizeHeight(state, val) {
    state.modelSize.height = val;
  },

  updateModelSizeWidth(state, val) {
    state.modelSize.width = val;
  },

  resetModelSize(state) {
    state.modelSize.width = '';
    state.modelSize.height = '';
  },

  updateQueryParamsElement(state, val) {
    if (val.includes('l')) {
      state.queryParams.element.logo = false;
    }
    if (val.includes('b')) {
      state.queryParams.element.basket = false;
    }
    if (val.includes('c')) {
      state.queryParams.element.sum = false;
    }
    if (val.includes('t')) {
      state.queryParams.element.header = false;
    }
    if (val.includes('p')) {
      state.queryParams.element.price = false;
    }
  },

  updateQueryParamsSize(state, val) {
    for (let i = 0; i < val.length; i++) {
      switch (i) {
        case 0:
          state.queryParams.size.width = val[i];
          break;
        case 1:
          state.queryParams.size.height = val[i];
          break;
      }
    }
  },

  updateQueryParamsSystem(state, val) {
    state.queryParams.model.type = val;
  },

  updateQueryParamsSub(state, val) {
    state.queryParams.model.sub = val;
  },

  updateQueryParamsModel(state, val) {
    state.queryParams.model.model = val;
  },

  updateQueryParamsMaterial(state, val) {
    state.queryParams.model.material = val;
  },
};
